import axios from "../../utils/axios";

export const getBlog = async (blogId) => {
  const response = await axios.get(`/blogs/${blogId}`);
  return response.data;
};

export const updateBlog = async (blogId, updateValue) => {
  const response = await axios.patch(`/blogs/${blogId}`, { ...updateValue });
  return response.data;
};
